// extracted by mini-css-extract-plugin
export default {"chatToggleButton":"chatToggle_chatToggleButton__gRAY6","chatToggleButton__icon":"chatToggle_chatToggleButton__icon__e90PB"};